import { render, staticRenderFns } from "./ListRelacionados.vue?vue&type=template&id=f3660e44&"
import script from "./ListRelacionados.vue?vue&type=script&lang=js&"
export * from "./ListRelacionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports